import { useFormAddressModel } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/hooks/use-address";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomAddress = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { address } = viewModel;

	return {
		...useFormAddressModel({ address, onSetViewModel }),
	};
};
